/**
 * État partagé du champ de recherche /recherche (Karim 2026-06-25).
 *
 * En mode page de recherche, la searchbar est REMONTÉE dans le header global
 * (AppHeader) à la place des liens « Associations / Cagnottes / Tap to Pay /
 * Pourquoi c'est gratuit ». La page /recherche n'affiche plus sa propre
 * searchbar — elle lit cet état pour filtrer ses listings.
 *
 * On utilise `useState` (Nuxt) plutôt qu'un ref module-scoped pour rester
 * SSR-safe (état isolé par requête côté serveur).
 */
export function useRechercheSearchQuery() {
  return useState<string>("recherche-search-query", () => "");
}

export interface RechercheCityOption {
  slug: string;
  name: string;
  count: number;
}

/**
 * Liste des villes disponibles, partagée depuis la page /recherche vers
 * AppHeader (qui héberge la searchbar enrichie en mode /recherche).
 * La page met à jour cet état après son fetch by-city.
 */
export function useRechercheCities() {
  return useState<RechercheCityOption[]>("recherche-cities", () => []);
}

export interface RechercheLiveResult {
  type: "association" | "cagnotte" | "evenement" | "adhesion";
  title: string;
  subtitle?: string;
  href: string;
  image?: string | null;
}

/**
 * Résultats live affichés dans le panel de la searchbar enrichie au fur
 * et à mesure que l'utilisateur tape dans le champ Quoi. La page /recherche
 * calcule ces résultats depuis ses listings déjà chargés (debouncé) puis
 * pousse dans cet état.
 */
export function useRechercheLiveResults() {
  return useState<RechercheLiveResult[]>("recherche-live-results", () => []);
}

/**
 * Slug de la ville actuellement sélectionnée comme FILTRE (sync avec
 * l'URL côté page). Le header peut le lire pour pré-remplir le champ Où,
 * et le modifier via emit `select-ville`. La page écoute et update son
 * `selectedVille` local.
 */
export function useRechercheSelectedVille() {
  return useState<string | null>("recherche-selected-ville", () => null);
}
